/**
 * @generated SignedSource<<6c499936a5e1fbdd5420d884e81cac90>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PasswordResetInput = {
  clientMutationId?: string | null | undefined;
  name?: string | null | undefined;
  password: string;
  token: string;
};
export type PasswordResetMutation$variables = {
  input: PasswordResetInput;
};
export type PasswordResetMutation$data = {
  readonly passwordReset: {
    readonly status: string | null | undefined;
  };
};
export type PasswordResetMutation = {
  response: PasswordResetMutation$data;
  variables: PasswordResetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PasswordResetPayload",
    "kind": "LinkedField",
    "name": "passwordReset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PasswordResetMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PasswordResetMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e05e4b0a2f81940b37a5d8e06a032862",
    "id": null,
    "metadata": {},
    "name": "PasswordResetMutation",
    "operationKind": "mutation",
    "text": "mutation PasswordResetMutation(\n  $input: PasswordResetInput!\n) {\n  passwordReset(input: $input) {\n    status\n  }\n}\n"
  }
};
})();

(node as any).hash = "6a9702622ab22232a72ee110a3766359";

export default node;
